import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AppConfigService } from '../../../services/app-config.service';
import { SecurityService } from '../../../services/security.service';
import { ISignUpFormGroup } from '../../../interfaces/sign-up.interface';
import { LoginBackgroundService } from '../../../services/login-background.service';
import { ApplicationId, strictEmailValidator } from '../../../constants';

@Component({
  selector: 'com-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
})
export class SignUpComponent {
  isSuccess: boolean;
  submissionError: boolean;

  signUpFormGroup = new FormGroup<ISignUpFormGroup>({
    email: new FormControl<string>('', [Validators.required, strictEmailValidator]),
    firstName: new FormControl<string>('', [Validators.required]),
    lastName: new FormControl<string>('', [Validators.required]),
    reCaptcha: new FormControl<string>('', [Validators.required]),
  });

  get email() {
    return this.signUpFormGroup.controls.email;
  }

  get reCaptcha() {
    return this.signUpFormGroup.controls.reCaptcha;
  }

  get firstName() {
    return this.signUpFormGroup.controls.firstName;
  }

  get lastName() {
    return this.signUpFormGroup.controls.lastName;
  }

  get siteId() {
    return this.env.config.reCaptchaSiteId;
  }

  get headerText() {
    if (this.isSuccess) {
      return 'Check your mail';
    } else {
      return 'Sign Up';
    }
  }

  constructor(
    private security: SecurityService,
    private env: AppConfigService,
    loginBackground: LoginBackgroundService
  ) {
    loginBackground.showLoginBackground = true;
  }

  createNewLogin(): void {
    this.signUpFormGroup.markAllAsTouched();
    if (this.signUpFormGroup.invalid) {
      this.signUpFormGroup.markAsDirty();
      return;
    } else {
      var clientType: string;
      switch (this.env.config.applicationId) {
        case ApplicationId.DataPortal:
          clientType = 'DataPortal';
          break;
        default:
          clientType = 'eLicensing';
          break;
      }

      this.submissionError = false;
      this.security
        .requestNewLogin({
          email: this.signUpFormGroup.value.email,
          firstName: this.signUpFormGroup.value.firstName,
          lastName: this.signUpFormGroup.value.lastName,
          accounts: [],
          clientType: clientType,
        })
        .subscribe({
          next: (result) => {
            this.isSuccess = result.success;
          },
          error: (err) => {
            this.submissionError = true;
            console.log(`${err.message} : Error in submitting sign up request. (${err.status}) : LOGGING_SOURCE`);
          },
        });
    }
  }

  startLogin() {
    this.security.startAuthentication();
  }
}
